var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.5,
    stroke: "#FF7F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 5.25L7 7.4375M7 7.4375L4.8125 5.25M7 7.4375L4.8125 9.625M7 7.4375L9.1875 9.625",
    stroke: "#FF7F00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaudit);
export default __webpack_public_path__ + "static/media/reaudit.4aa58267723ab43caf85b9c8c9e80570.svg";
export { ForwardRef as ReactComponent };